/*---------------------------------------------------------------------------------------------
 *  Copyright (c) i-Bridge Systems Philippines Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
import { Typography, Box, Grid } from '@mui/material';
import { BoxContainer } from '../Containers/BoxContainer';
import { EmployeeBadge } from '../index';

export const DepartmentBox = (props) => {
  return (
    <BoxContainer bg={{ bgcolor: 'rgb(26, 32, 44, 0.85)' }}>
      <Box
        sx={{
          display: 'flex',
          width: '100%',
          flexDirection: 'column',
          m: 3,
        }}
      >
        <Typography
          variant="h4"
          sx={{
            textTransform: 'uppercase',
            fontWeight: 600,
            pb: 3,
            textAlign: 'center',
          }}
        >
          {props.deptName}
        </Typography>
        <Grid container spacing={2} sx={{ px: 2, mb: 2 }}>
          {props.members.map((member, index) => (
            <EmployeeBadge
              key={index}
              name={`${member.firstname} ${member.lastname}`}
              // jobTitle={"Developer"}
              // Job Title is temporarily hidden as of 1.0.0-beta.3
              removeIcon={false}
            />
          ))}
        </Grid>
      </Box>
    </BoxContainer>
  );
};
